<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Tipos de Componente
      </h1>
      <p class="text-gray-600 dark:text-gray-400">
        Catálogo de tipos de componente
      </p>
    </div>
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <div class="flex justify-between items-center">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
            Lista de Tipos de Componente
          </h2>
          <button @click="showModal = true" class="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            Nuevo Tipo
          </button>
        </div>
        <!-- Filtro -->
        <form @submit.prevent="onFilter" class="flex flex-wrap gap-2 mt-4">
          <input v-model="filters.nombre" type="text" placeholder="Nombre" class="px-3 py-2 rounded border text-sm bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200" />
          <button type="submit" class="px-4 py-2 rounded bg-blue-500 text-white text-sm font-semibold hover:bg-blue-600 transition">Buscar</button>
          <button type="button" @click="onClearFilters" class="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-sm font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition">Limpiar</button>
        </form>
      </div>
      <div class="p-6">
        <div v-if="error" class="text-red-500 text-center mb-4">{{ error }}</div>
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs uppercase bg-gray-100 dark:bg-gray-800 dark:text-gray-300 border-b-2 border-gray-200 dark:border-gray-700">
              <tr>
                <th class="px-4 py-2 font-bold">ID</th>
                <th class="px-4 py-2 font-bold">Nombre</th>
                <th class="px-4 py-2 font-bold">Tipo Costo</th>
                <th class="px-4 py-2 font-bold">Posición Fórmula</th>
                <th class="px-4 py-2 font-bold">Pago Herramental</th>
                <th class="px-4 py-2 font-bold">Acciones</th>
                <th class="px-4 py-2 font-bold"> </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tipo in tipos" :key="tipo.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 even:bg-gray-50 dark:even:bg-gray-700">
                <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">{{ tipo.id }}</td>
                <td class="px-4 py-2 text-gray-700 dark:text-gray-200">{{ tipo.nombre }}</td>
                <td class="px-4 py-2">
                  <span
                    v-if="tipo.tipo_costo === 'UNICO'"
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
                  >
                    Único
                  </span>
                  <span
                    v-else-if="tipo.tipo_costo === 'POR_MEDIDA'"
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200"
                  >
                    x Área
                  </span>
                  <span
                    v-else
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
                  >
                    N/D
                  </span>
                </td>
                <td class="px-4 py-2">
                  <span
                    v-if="tipo.posicion_formula === 'suma_base'"
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                  >
                    Suma Base
                  </span>
                  <span
                    v-else-if="tipo.posicion_formula === 'suma_adicional'"
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200"
                  >
                    Suma Adicional
                  </span>
                  <span
                    v-else
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
                  >
                    No Incluir
                  </span>
                </td>
                <td class="px-4 py-2">
                  <span
                    v-if="tipo.afecta_pago_herramental"
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                  >
                    SÍ
                  </span>
                  <span
                    v-else
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
                  >
                    NO
                  </span>
                </td>
                <td class="px-4 py-2 whitespace-nowrap text-right">
                  <button
                    @click="openDrawer(tipo)"
                    class="relative text-violet-600 hover:text-violet-800 p-2 rounded transition align-middle"
                    title="Ver componentes"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
                    </svg>
                    <span
                      v-if="tipo.componentes"
                      class="absolute -top-1 -right-1 bg-violet-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full border-2 border-white dark:border-gray-900"
                      style="min-width: 1.5em; text-align: center;"
                    >
                      {{ tipo.componentes.length }}
                    </span>
                  </button>
                  <button @click="openEditModal(tipo)" class="text-blue-500 hover:text-blue-700 mr-2" title="Editar">
                    <svg class="w-5 h-5 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536M9 13h3l8-8a2.828 2.828 0 00-4-4l-8 8v3z"/>
                    </svg>
                  </button>
                  <button @click="onDeleteTipo(tipo)" class="text-red-500 hover:text-red-700" title="Eliminar">
                    <svg class="w-5 h-5 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>
                </td>
              </tr>
              <tr v-if="tipos.length === 0">
                <td colspan="7" class="text-center py-4 text-gray-400">No hay tipos de componente para mostrar.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Paginador -->
        <Pagination 
          :current-page="currentPage" 
          :last-page="lastPage" 
          @page-changed="goToPage" 
        />
      </div>
    </div>
    <!-- Modal para Nuevo/Editar Tipo -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div class="p-6 border-b border-gray-200 dark:border-gray-700">
          <div class="flex justify-between items-center">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
              {{ editMode ? 'Editar Tipo de Componente' : 'Nuevo Tipo de Componente' }}
            </h3>
            <button @click="closeModal" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
        </div>
        <form @submit.prevent="editMode ? updateTipo() : createTipo()" class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre *</label>
            <input v-model="tipoForm.nombre" type="text" required class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white" placeholder="Ingrese el nombre" />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de Costo *</label>
            <select v-model="tipoForm.tipo_costo" required class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white">
              <option value="">Seleccione...</option>
              <option value="UNICO">Costo único</option>
              <option value="POR_MEDIDA">Por medida (área)</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Posición en Fórmula *</label>
            <select v-model="tipoForm.posicion_formula" required class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-700 dark:text-white">
              <option value="">Seleccione...</option>
              <option value="suma_base">Suma Base (se divide entre poses)</option>
              <option value="suma_adicional">Suma Adicional (se suma directo)</option>
              <option value="no_incluir">No incluir en fórmula</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">¿Afecta Pago Herramental?</label>
            <div class="flex items-center space-x-4">
              <label class="flex items-center">
                <input
                  v-model="tipoForm.afecta_pago_herramental"
                  :value="true"
                  type="radio"
                  name="afecta_pago_herramental"
                  class="mr-2 text-violet-600 focus:ring-violet-500"
                />
                <span class="text-sm text-gray-700 dark:text-gray-300">Sí</span>
              </label>
              <label class="flex items-center">
                <input
                  v-model="tipoForm.afecta_pago_herramental"
                  :value="false"
                  type="radio"
                  name="afecta_pago_herramental"
                  class="mr-2 text-violet-600 focus:ring-violet-500"
                />
                <span class="text-sm text-gray-700 dark:text-gray-300">No</span>
              </label>
            </div>
          </div>
          <div class="flex justify-end space-x-3 pt-4">
            <button type="button" @click="closeModal" class="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">Cancelar</button>
            <button type="submit" :disabled="loading" class="px-4 py-2 bg-violet-600 text-white rounded-md hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-2">
              <svg v-if="loading" class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
              {{ loading ? (editMode ? 'Actualizando...' : 'Creando...') : (editMode ? 'Actualizar' : 'Crear') }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Drawer de componentes -->
    <div v-if="drawerOpen" class="fixed inset-0 z-50 flex">
      <div class="fixed inset-0 bg-black bg-opacity-30" @click="closeDrawer"></div>
      <aside class="relative ml-auto w-full max-w-md bg-white dark:bg-gray-900 h-full shadow-xl transition-transform duration-300 flex flex-col">
        <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Componentes de {{ drawerTipo?.nombre }}</h3>
          <button @click="closeDrawer" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="p-6 flex-1 overflow-y-auto">
          <div v-if="drawerTipo && drawerTipo.componentes && drawerTipo.componentes.length">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead class="text-xs uppercase bg-gray-100 dark:bg-gray-800 dark:text-gray-300 border-b-2 border-gray-200 dark:border-gray-700">
                <tr>
                  <th class="px-4 py-2 font-bold">ID</th>
                  <th class="px-4 py-2 font-bold">Nombre</th>
                  <th class="px-4 py-2 font-bold">Costo Unitario</th>
                  <th class="px-4 py-2 font-bold">Precio Unitario</th>
                  <th class="px-4 py-2 font-bold">Activo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="comp in drawerTipo.componentes" :key="comp.id" class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 even:bg-gray-50 dark:even:bg-gray-700">
                  <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">{{ comp.id }}</td>
                  <td class="px-4 py-2 text-gray-700 dark:text-gray-200">{{ comp.nombre }}</td>
                  <td class="px-4 py-2 text-gray-700 dark:text-gray-200">{{ comp.costo_unitario }}</td>
                  <td class="px-4 py-2 text-gray-700 dark:text-gray-200">{{ comp.precio_unitario }}</td>
                  <td class="px-4 py-2">
                    <span v-if="comp.activo" class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full dark:bg-green-900 dark:text-green-300">Activo</span>
                    <span v-else class="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300">Inactivo</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-gray-400 text-center py-8">No hay componentes para este tipo.</div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue'
import { useHttp } from '@/composables/useHttp'
import Swal from 'sweetalert2'
import Pagination from '@/components/Pagination.vue'

const tipos = ref([])
const currentPage = ref(1)
const lastPage = ref(1)
const perPage = 12
const showModal = ref(false)
const editMode = ref(false)
const tipoForm = ref({
  id: null,
  nombre: '',
  tipo_costo: '',
  posicion_formula: 'no_incluir',
  afecta_pago_herramental: false
})
const filters = ref({ nombre: '' })
const { get, post, del, loading, error, data } = useHttp()

const drawerOpen = ref(false)
const drawerTipo = ref(null)

function openDrawer(tipo) {
  drawerTipo.value = tipo
  drawerOpen.value = true
}
function closeDrawer() {
  drawerOpen.value = false
  drawerTipo.value = null
}

const fetchTipos = async (page = 1) => {
  try {
    const params = new URLSearchParams()
    params.append('page', page)
    params.append('per_page', perPage)
    if (filters.value.nombre) params.append('nombre', filters.value.nombre)
    await get(`tipos-componentes?${params.toString()}`)
    if (data.value) {
      if (Array.isArray(data.value)) {
        tipos.value = data.value
        currentPage.value = 1
        lastPage.value = 1
      } else {
        tipos.value = data.value.data
        currentPage.value = data.value.current_page
        lastPage.value = data.value.last_page
      }
    }
  } catch (err) {
    tipos.value = []
  }
}

const goToPage = (page) => {
  if (page >= 1 && page <= lastPage.value) fetchTipos(page)
}

const onFilter = () => { fetchTipos(1) }
const onClearFilters = () => { filters.value = { nombre: '' }; fetchTipos(1) }

const closeModal = () => {
  showModal.value = false
  editMode.value = false
  tipoForm.value = {
    id: null,
    nombre: '',
    tipo_costo: '',
    posicion_formula: 'no_incluir',
    afecta_pago_herramental: false
  }
}

const openEditModal = (tipo) => {
  tipoForm.value = { ...tipo }
  showModal.value = true
  editMode.value = true
}

const createTipo = async () => {
  try {
    await post('tipos-componentes', {
      nombre: tipoForm.value.nombre,
      tipo_costo: tipoForm.value.tipo_costo,
      posicion_formula: tipoForm.value.posicion_formula,
      afecta_pago_herramental: tipoForm.value.afecta_pago_herramental
    })
    closeModal()
    await fetchTipos(currentPage.value)
    Swal.fire({ icon: 'success', title: 'Tipo creado', text: 'El tipo de componente se creó exitosamente.', timer: 2000, showConfirmButton: false })
  } catch (err) {
    Swal.fire({ icon: 'error', title: 'Error', text: error.value || 'Error desconocido al crear tipo' })
  }
}

const updateTipo = async () => {
  try {
    await post(`tipos-componentes/${tipoForm.value.id}?_method=PUT`, {
      nombre: tipoForm.value.nombre,
      tipo_costo: tipoForm.value.tipo_costo,
      posicion_formula: tipoForm.value.posicion_formula,
      afecta_pago_herramental: tipoForm.value.afecta_pago_herramental
    })
    closeModal()
    await fetchTipos(currentPage.value)
    Swal.fire({ icon: 'success', title: 'Tipo actualizado', text: 'El tipo de componente se actualizó exitosamente.', timer: 2000, showConfirmButton: false })
  } catch (err) {
    Swal.fire({ icon: 'error', title: 'Error', text: error.value || 'Error desconocido al actualizar tipo' })
  }
}

const onDeleteTipo = async (tipo) => {
  const result = await Swal.fire({
    title: `¿Eliminar tipo?`,
    text: `¿Seguro que deseas eliminar "${tipo.nombre}"? Esta acción no se puede deshacer.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  })
  if (result.isConfirmed) {
    try {
      await del(`tipos-componentes/${tipo.id}`)
      await Swal.fire({ title: '¡Eliminado!', text: 'El tipo de componente ha sido eliminado correctamente.', icon: 'success', timer: 1800, showConfirmButton: false })
      fetchTipos(currentPage.value)
    } catch (err) {
      Swal.fire('Error', 'No se pudo eliminar el tipo de componente.', 'error')
    }
  }
}

watchEffect(() => { fetchTipos(currentPage.value) })
</script> 